import { render, staticRenderFns } from "./Fragen.vue?vue&type=template&id=49eb43c4"
import script from "./Fragen.vue?vue&type=script&lang=js"
export * from "./Fragen.vue?vue&type=script&lang=js"
import style0 from "./Fragen.vue?vue&type=style&index=0&id=49eb43c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports